export interface SerializedSaveQueue {
  enqueue(task: () => Promise<void>): Promise<void>;
}

export function createSerializedSaveQueue(): SerializedSaveQueue {
  let tail = Promise.resolve();

  return {
    enqueue(task) {
      const result = tail.then(task, task);
      tail = result.catch(() => undefined);
      return result;
    },
  };
}

export function formatSavedTime(date = new Date()): string {
  return [date.getHours(), date.getMinutes(), date.getSeconds()]
    .map((value) => String(value).padStart(2, "0"))
    .join(":");
}
